import { Text } from '../../../text/text.component';
import { TextLink } from '../../../text-link/text-link.component';
import { TableCommonStyles } from '../../common-styles';

export const FilterHeader = ({ render, label, onClick, disabled }) => {
  const filterSectionHeaderStyles = TableCommonStyles.tableFilterStyles({
    type: 'filterSectionHeader',
  });

  return (
    <section css={filterSectionHeaderStyles}>
      <Text weight='semibold'>{label ?? render('Header')}</Text>
      <TextLink disabled={disabled} weight='semibold' onClick={onClick}>
        Clear
      </TextLink>
    </section>
  );
};
